const getKey = (path) => {
    const pathArray = path.split('.');
    const resource = pathArray[0];

    let key;
    let itemId = pathArray[1] ? pathArray[1] : false;
    switch(pathArray.length){
        case 1:
            key = resource; break;
        case 2:
            key = `${resource}.item`; break;
        case 3:
            key = `${resource}.item.children`; break;
        case 4:
            key = `${resource}.item.children.item`; break;
    }

    return {key, resource, itemId}
}

const normalise = data => {
    return data.reduce((response, item)=>{
        response[item.id] = item;
        return response;
    }, {})
}

const transform = (path, data) => {
    switch(path){
        case 'addresses':
        case 'benefits':
        case 'rewards':
        case 'transactions':
            return normalise(data)
        case 'addresses.item':
        case 'benefits.item':
        case 'rewards.item':
        case 'transactions.item':
        case 'lists.item.children':
        case 'lists.item.children.item':
            return {[data.id]:data}
        case 'lists':
            return data.reduce((response, item)=>{
                response[item.handle] = item;
                response[item.handle].id = item.handle;
                response[item.handle].items = normalise(item.items);
                return response;
            }, {})
        case 'identities':
            return data.reduce((response, item)=>{
                response[item.handle] = item;
                response[item.handle].id = item.handle;
                return response;
            }, {})
        case 'lists.item':
            return {
                [data.handle]: {
                    ...data,
                    id: data.handle,
                    items: normalise(data.items)
                }
            }
        case 'identities.item':
            return {
                [data.handle]: {
                    ...data,
                    id: data.handle
                }
            }
        default:
            return data
    }
}

const getAction = (resource, method, key) =>{
    switch(method){
        case 'hydrate': 
            return `${resource}.hydrate`
        case 'get': 
        case 'put': 
            switch(key){
                case 'lists.item.children':
                case 'lists.item.children.item':
                    return 'lists.updateItem'
                default:
                    if(method === 'get'){return `${resource}.set`}
                    return `${resource}.update`
            }

        case 'post': 
            if(key === 'lists.item.children'){
                return 'lists.addItem'
            }
            return `${resource}.add`
            
        case 'delete': 
            if(key === 'lists.item.children.item'){
                return 'lists.removeItem'
            }
            return `${resource}.remove`
    }
}

export default (method, path, data, id) => {
    let payload = {
        init: true,
        loading: false,
        error: false,
    }

    let {key, resource, itemId} = getKey(path);
    if(itemId){
        payload.parent_id = itemId;
    }

    let type = getAction(resource, method, key);
    switch(method){
        case 'get': 
        case 'put': 
        case 'hydrate': 
            payload.data = transform(key, data);
            break;
        case 'post': 
            payload.data = transform(key, data);
            break;
        case 'delete': 
            payload.id = id;
            break;
    }

    return {type, payload}
}